module.exports = __webpack_public_path__ + "static/media/129.a0284b83.mp3";